import { render } from "./ImageCustom.vue?vue&type=template&id=4be33f68&scoped=true"
import script from "./ImageCustom.vue?vue&type=script&lang=js"
export * from "./ImageCustom.vue?vue&type=script&lang=js"

import "./ImageCustom.vue?vue&type=style&index=0&id=4be33f68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be33f68"]])

export default __exports__